import Image, { type ImageProps } from "@/shared/lib/router/image";
import { useTenant } from "@/shared/config/tenant";

type TenantLogoProps = Omit<ImageProps, "src" | "alt"> & {
    variant: "mark" | "wordmark";
};

export function TenantLogo({ variant, ...props }: TenantLogoProps) {
    const tenant = useTenant();
    const src = variant === "mark" ? tenant.logoUrl : tenant.logoWordmarkUrl;
    return <Image src={src} alt={tenant.name} {...props} />;
}
